export function roundToHundredths(value: number) {
  return Math.round(value * 100 + Number.EPSILON) / 100;
}

export function formatNumberDecimals(num: number) {
  return num % 1 === 0 ? num : num.toFixed(2);
}
